exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.clients td[data-v-57101d99]{padding-top:12px;padding-bottom:12px}table.clients tr:first-child td[data-v-57101d99]:first-child{border-top:none;padding-top:0}table.clients td a[data-v-57101d99]{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57101d99","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/clients/ClientList.vue
// module id = 9GoI
// module chunks = 0